import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import "./HeroSection.css";
import CarSteamImage from "../assets/car-steam-wash.png";
import Logo from "../assets/logo.png";

const HeroSection = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false); // Close the mobile menu if open
    }
  };
  const handleLogout = async () => {
    try {
      await logout();
      setMenuOpen(false);
    } catch (error) {
      console.error("Failed to logout:", error);
    }
  };

  const handleLogin = () => {
    navigate("/auth");
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);

  return (
    <div className="hero" style={{ backgroundImage: `url(${CarSteamImage})` }}>
      <div className="overlay"></div>
      <nav className="nav">
        <div className="nav-logo">
          <img src={Logo} alt="Steam and Drive" className="logo-image" />
        </div>{" "}
        <div className="nav-links">
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              handleScrollTo("about");
            }}
          >
            About Us
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleScrollTo("contact");
            }}
          >
            Contact Us
          </a>{" "}
          {user ? (
            <div className="user-menu">
              <span className="user-name">
                {user.displayName || user.email}
              </span>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <button onClick={handleLogin} className="login-btn">
              Login
            </button>
          )}
        </div>
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          &#9776;
        </div>
      </nav>{" "}
      {menuOpen && (
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <button className="close-menu" onClick={() => setMenuOpen(false)}>
            &times;
          </button>
          {user && (
            <div className="mobile-user-info">
              Welcome, {user.displayName || user.email}
            </div>
          )}
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              handleScrollTo("about");
            }}
          >
            About Us
          </a>{" "}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleScrollTo("contact");
            }}
          >
            Contact Us
          </a>{" "}
          {user ? (
            <button
              onClick={handleLogout}
              className="mobile-nav-button logout-btn"
            >
              Logout
            </button>
          ) : (
            <button
              onClick={handleLogin}
              className="mobile-nav-button login-btn"
            >
              Login
            </button>
          )}
        </div>
      )}{" "}
      <div className="hero-content">
        <h1>
          NO MATTER THE MESS, we're ready to impress.
          <br />
          Steam wash on the way to your community.
        </h1>
        <div className="buttons">
          <button onClick={() => handleScrollTo("about")}>Learn More</button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
